module.exports = __webpack_public_path__ + "static/media/11BeaujolaisAQ5151.a702bf7d.PNG";